import {useCallback, useContext, useRef} from 'react';
import {useSelector} from 'react-redux';
import {throttle} from 'lodash';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {
  selectBackgroundColor,
  selectRecentBackgroundColors,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {useBackground} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Background/actions/useBackground';
import {ColorPicker} from './ColorPicker';

export const BackgroundColorPicker = ({onColorChange = () => {}}) => {
  const {bkgColor, setBkgColor} = useContext(EventCreateContext);
  const throttledColorChange = useRef(throttle(onColorChange, 500)).current;
  const isLargishAndUp = useIsLargishAndUp();
  const recentBackgroundColors = useSelector(selectRecentBackgroundColors);
  const backgroundColor = useSelector(selectBackgroundColor);
  const {selectedBackground} = useBackground();
  const selectedColor = (!selectedBackground?.src && backgroundColor) || '';

  const onChangeHandler = useCallback(
    (color) => {
      setBkgColor(color);
      throttledColorChange(color);
    },
    [onColorChange]
  );

  return (
    <ColorPicker
      recentColors={recentBackgroundColors}
      reduxKey="recentBackgroundColors"
      color={bkgColor}
      isActive={!!backgroundColor}
      className="create-flow-color-picker"
      onChangeHandler={onChangeHandler}
      isolateDropper={!isLargishAndUp}
      highlight={!isLargishAndUp}
      selectedColor={selectedColor}
      recentColorLimit={isLargishAndUp ? 6 : 3}
    />
  );
};
